
    var runtime = require('vue-svg-component-runtime')
    module.exports = {
      __esModule: true,
      default: runtime.svgComponent({
  "tag": "svg",
  "attrsMap": {
    "version": "1.1",
    "id": "图层_1",
    "xmlns": "http://www.w3.org/2000/svg",
    "xmlns:xlink": "http://www.w3.org/1999/xlink",
    "x": "0px",
    "y": "0px",
    "viewBox": "0 0 128 128",
    "style": "enable-background:new 0 0 128 128;",
    "xml:space": "preserve"
  },
  "children": [
    {
      "tag": "g",
      "children": [
        {
          "tag": "polygon",
          "attrsMap": {
            "class": "st0",
            "points": "8.9,49.5 40.2,49.5 40.2,57.4 26.9,70.7 40.2,70.7 40.2,78.5 14.3,78.5 14.3,70.4 27.5,57.2 \n\t\t18.1,57.2 18.1,60.6 6.9,49.5 \t"
          }
        },
        {
          "tag": "path",
          "attrsMap": {
            "d": "M121.1,57.5l-1.1,6.3h-4.9l-1.2,9h4.5l2.4-1.7l-2.1,7.5h-13.7l2.2-14.8h-7.2l-7.8,14.9h-8l7.8-14.9h-6.8l1.7-6.3H121.1z\n\t\t M119.6,49.3l-0.9,5.9h-29l1-5.9H119.6z"
          }
        },
        {
          "tag": "g",
          "children": [
            {
              "tag": "polygon",
              "attrsMap": {
                "points": "56.4,62.5 55.7,50.9 48.7,50.9 49.4,62.5 \t\t"
              }
            },
            {
              "tag": "polygon",
              "attrsMap": {
                "points": "63.8,60.9 66.2,57.3 76.1,57.3 74.3,60.9 80.3,60.9 83.6,52.2 68.1,52.2 69.5,49.4 59.6,49.4 62.2,50.5 \n\t\t\t57.1,60.9 \t\t"
              }
            },
            {
              "tag": "polygon",
              "attrsMap": {
                "points": "73.1,66 69.9,66 73.9,58.6 66.9,58.6 55.7,78.7 63,78.7 67.9,69.6 72.1,78.6 80.8,78.6 78,76.8 \t\t"
              }
            },
            {
              "tag": "polygon",
              "attrsMap": {
                "points": "49.2,64 44.8,78.6 51.8,78.6 56.2,64 \t\t"
              }
            }
          ]
        }
      ]
    }
  ]
})
    }
  